import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Accessibility = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <Button variant="ghost" className="mb-6" asChild>
        <Link to="/" className="flex items-center">
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Home
        </Link>
      </Button>

      <h1 className="text-4xl font-bold mb-8">Accessibility Statement</h1>

      <div className="prose prose-slate max-w-none space-y-6">
        <section>
          <h2 className="text-2xl font-semibold mb-4">Our Commitment</h2>
          <p>
            Scienza Health is committed to ensuring digital accessibility for people with disabilities. We are continually improving the user experience for everyone, and applying the relevant accessibility standards.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">Compliance Status</h2>
          <p>
            We conform to the Web Content Accessibility Guidelines (WCAG) 2.1 level AA standards. These guidelines explain how to make web content more accessible for people with disabilities and more user-friendly for everyone.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">Accessibility Features</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Semantic HTML structure for better screen reader compatibility</li>
            <li>ARIA landmarks and labels where appropriate</li>
            <li>Sufficient color contrast ratios</li>
            <li>Keyboard navigation support</li>
            <li>Alt text for images</li>
            <li>Resizable text without loss of functionality</li>
            <li>Clear heading hierarchy</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
          <p>
            We welcome your feedback on the accessibility of the Scienza Health website. If you encounter accessibility barriers or have suggestions for improvement, please contact us at:
          </p>
          <ul className="list-disc pl-6 mt-2">
            <li>Email: accessibility@scienzahealth.com</li>
            <li>Phone: (888) 608-8482 </li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default Accessibility;